import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import * as s from './checkbox.module.css'

interface CheckboxProps {
    checked: boolean,
    text?: string,
    onChange?: any,
}

export const Checkbox: React.FC<CheckboxProps> = ({ checked, text, onChange }) => {
    return (
        <div
            className={s.container}
            onClick={ onChange }
        >            
            <div className={s.box}>
                {checked && <FontAwesomeIcon className={s.check} icon={faCheck} color="#7A3FC7" /> }
            </div>
            {!!text && <div className={s.text}> 
                {text}
            </div>}
        </div>
    )
}